import { RefObject, useRef } from 'react'

function useLatest<T>(val: T): RefObject<T> {
  const ref = useRef(val)
  ref.current = val
  return ref
}

export { useLatest }
